import { h, defineComponent } from 'vue';
import { box, button, container, message, pageSubtitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { pushRoute } from '@/ui/helpers/uiHelper';

export const NotFoundPage = defineComponent({
  name: 'NotFoundPage',
  setup() {
    return () => h('div', { class: 'p-12' }, [container(
      [
        box([
          message('error', [
            pageSubtitle(t('error.404')),
            h('div', { class: 'content' }, t('error.not-found-page')),
            button(t('common.go-home'), () => pushRoute({ name: 'home' })),
          ]),
        ]),
      ],
      'small',
    )]);
  },
});

export const renderNotFoundPage = () => h(NotFoundPage);
